export type CompanySettingsSectionId = 'informacoes' | 'marca-dagua' | 'equipe' | 'atividades' | 'integracoes' | 'atendente-ia' | 'assinatura'

export type CompanySettingsResource = 'settings' | 'members' | 'subscriptions'

export interface CompanySettingsSection {
  id: CompanySettingsSectionId
  label: string
  group: string
  path: string
  resource: CompanySettingsResource
}

export const COMPANY_SETTINGS_SECTIONS: CompanySettingsSection[] = [
  { id: 'informacoes', label: 'Informações', group: 'Geral', path: 'geral/informacoes', resource: 'settings' },
  { id: 'marca-dagua', label: "Marca d'água", group: 'Geral', path: 'geral/marca-dagua', resource: 'settings' },
  { id: 'equipe', label: 'Equipe', group: 'Pessoas', path: 'equipe', resource: 'members' },
  { id: 'atividades', label: 'Atividades', group: 'Pessoas', path: 'atividades', resource: 'members' },
  { id: 'integracoes', label: 'Integrações', group: 'Canais', path: 'integracoes', resource: 'settings' },
  { id: 'atendente-ia', label: 'Atendente IA', group: 'Canais', path: 'atendente-ia', resource: 'settings' },
  { id: 'assinatura', label: 'Assinatura', group: 'Plano', path: 'assinaturas', resource: 'subscriptions' }
]

const SETTINGS_ROUTE = /^\/empresas\/[^/]+\/configuracoes\/(.+?)\/?$/

export const companySettingsPath = (companyId: string, section: CompanySettingsSection): string =>
  `/empresas/${companyId}/configuracoes/${section.path}`

export function companySettingsSections(can: (resource: CompanySettingsResource) => boolean): CompanySettingsSection[] {
  return COMPANY_SETTINGS_SECTIONS.filter(section => can(section.resource))
}

export function companySettingsSectionOf(pathname: string): CompanySettingsSection | null {
  const rest = SETTINGS_ROUTE.exec(pathname)?.[1]
  if (!rest) return null
  return COMPANY_SETTINGS_SECTIONS.find(section => rest === section.path || rest.startsWith(`${section.path}/`)) ?? null
}
